import { SORT, SEARCH } from 'constants/FilterConstants';
import * as types from 'modules/contactLists/actionTypes';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'text' | 'sort' } FilterContactListField */
/** @typedef {string | number | Array<string> | Array<number>} FilterValue */
/** @typedef {Record<FilterContactListField, FilterValue>} ContactListsFiltersReducer */

const persistedFilters = getPersistedFilters()?.filters?.contactLists ?? {};

const emptyState = {
  [SEARCH]: null,
  [SORT]: 'name,ASC',
};

/** @type {import("modules/global/reducers/filterSliceAdapter").FilterAdapter<ContactListsFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_CONTACT_LIST_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.SET_CONTACT_LIST_DASHBOARD_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_CONTACT_LIST_DASHBOARD_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_CONTACT_LIST_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
